import { TNotVisibleFields } from "utils/onErrorMutation";

export const notVisibleFieldsPlatform: TNotVisibleFields = [
  {
    name: "owner",
    title: "Владелец площадки"
  }
];
